import http from './http'
import qs from 'qs'

function getUser () {
  return http({
    method: 'GET',
    url: '/users/current'
  })
}

function getUserById (id) {
  return http({
    method: 'GET',
    url: '/users/' + id
  })
}

function getUsers () {
  return http({
    method: 'GET',
    url: '/users'
  })
}

function updateUser (firstName, lastName, email) {
  return http({
    method: 'PATCH',
    url: '/users/current/info',
    data: {
      firstName,
      lastName,
      email
    }
  })
}

function updateUserById (id, params) {
  return http({
    method: 'PATCH',
    url: '/users/' + id + '/info',
    data: params
  })
}

function updateUserPassword (oldPassword, newPassword) {
  return http({
    method: 'PUT',
    url: '/users/current/password',
    data: qs.stringify({
      oldPassword,
      newPassword
    })
  })
}

function deleteUsersByArray (data) {
  return http({
    method: 'DELETE',
    url: '/users',
    data: data
  })
}

function deleteUserById (id) {
  return http({
    method: 'DELETE',
    url: '/users/' + id
  })
}

function createUser (params) {
  return http({
    method: 'POST',
    url: '/users',
    data: params
  })
}

function confirmUser (token, password) {
  return http({
    method: 'POST',
    url: '/users/verify/' + token,
    data: {
      password
    }
  })
}

function identifyUserByToken (token) {
  return http({
    method: 'GET',
    url: '/users/identify/' + token
  })
}

function resendInvitation (id) {
  return http({
    method: 'POST',
    url: '/users/' + id + '/resendInvitation/'
  })
}

function resetPassword (email, organizationId) {
  return http({
    method: 'POST',
    url: '/users/resetPassword',
    data: {
      email,
      organizationId
    }
  })
}

function exportUsers () {
  return http({
    method: 'GET',
    url: '/users/export'
  })
}

export {
  getUser,
  getUserById,
  getUsers,
  updateUser,
  updateUserById,
  updateUserPassword,
  deleteUserById,
  deleteUsersByArray,
  createUser,
  confirmUser,
  identifyUserByToken,
  resendInvitation,
  resetPassword,
  exportUsers
}



// WEBPACK FOOTER //
// ./src/services/api/user.js